import "./src/selection/index";
export {default as transition} from "./src/transition/index";
export {default as active} from "./src/active";
export {default as interrupt} from "./src/interrupt";



//////////////////
// WEBPACK FOOTER
// ../~/d3-transition/index.js
// module id = 0iav
// module chunks = 0